<template>
  <w-radio-list :values="genders" :title="title" :model="model" :disabled="disabled.all">
    <slot />
  </w-radio-list>
</template>

<script>
import { componentMixin } from '@/mixins/document/component';
import { GENDER } from '@/utils/constants';

// @vuese
// komponent do opcji tak lub nie
// @Group formComponents
export default {
  mixins: [componentMixin],
  data() {
    return {
      genders: GENDER
    };
  }
};
</script>
